import makeHSL from 'styles/makeHSL';

const makeColor = ({ hue }) => ({
  color: makeHSL({ hue, saturation: 0.69, lightness: 0.65 }),
  backgroundColor: makeHSL({ hue, saturation: 0.87, lightness: 0.93 }),
});

export default makeColor;
